import { createGlobalStyle } from 'styled-components';
import { breakpoints } from 'assets/breakpoints';
// import { color, font, mixin } from '../shared/utils/styles';

export default createGlobalStyle`
html, body, #root, #root>div {
  //height: 100%;
  margin: 0 auto;
  
  
  @media (max-width: ${breakpoints.desktop}) {
  max-width: 100%;
  }
  
}
body {
  background: #000;
  font-size: 0.9em;
  font-family: 'Roboto', sans-serif;
  font-weight: lighter;
  margin: 0;
  padding: 0;
  height: 100%;
  
  @media (min-width: ${breakpoints.desktop}) {
  background: #fff;
  }
  
}
img {
  border: 1px solid #ddd;
  padding: 1px;
  border-radius: 3px;
  height: auto;
  max-width: 100%;
}
a {
  text-decoration: none;
  color: black;
}
button {
  background: none;
  border: none;
  color: white;
  padding: 7px 12px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.1em;
  cursor: pointer;
  border-radius: 3px;
}
h1 {
  font-size: 1.4em;
}
h2 {
  font-size: 1.2em;
}
h3 {
  font-size: 1.1em;
}
h4 {
  font-size: 1em;
}
h5 {
  font-size: .9em;
}
i {
  font-size: 1.5em;
}
p {
    color: white;
}

.react-tabs {
  -webkit-tap-highlight-color: transparent;
  width: 100%;
}

.react-tabs__tab-list {
  border-bottom: 1px solid #aaa;
  margin: 0;
  padding: 0;
}

.react-tabs__tab {
  display: inline-block;
  border-bottom: none;
  bottom: -1px;
  position: relative;
  list-style: none;
  padding: 6px 0px;
  cursor: pointer;
  width: 50%;
  display: none;
}

.react-tabs__tab--selected {
  border-bottom: 5px #fff solid;
  color: white;
  border-radius: 5px 5px 0 0;
}

.react-tabs__tab--disabled {
  color: GrayText;
  cursor: default;
}

.react-tabs__tab:focus {
  box-shadow: 0 0 5px hsl(208, 99%, 50%);
  border-color: hsl(208, 99%, 50%);
  outline: none;
}

.react-tabs__tab:focus:after {
  content: "";
  position: absolute;
  height: 5px;
  left: -4px;
  right: -4px;
  bottom: -5px;
  background: #fff;
}

.react-tabs__tab-panel {
  display: none;
}

.react-tabs__tab-panel--selected {
  display: block;
  height: auto;
}

/**Carousel */

.carousel .control-arrow,
.carousel.carousel-slider .control-arrow {
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
    opacity: 1;
    filter: alpha(opacity=100);
    position: absolute;
    z-index: 2;
    top: 20px;
    background: none;
    border: 0;
    font-size: 32px;
    cursor: pointer;
}
.carousel .control-arrow:hover {
    opacity: 1;
    filter: alpha(opacity=100);
}
.carousel .control-arrow:before,
.carousel.carousel-slider .control-arrow:before {
    margin: 0 5px;
    display: inline-block;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    content: "";
}
.carousel .control-disabled.control-arrow {
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: inherit;
    display: none;
}
.carousel .control-prev.control-arrow {
    left: 0;
}
.carousel .control-prev.control-arrow:before {
    border-right: 8px solid #fff;
}
.carousel .control-next.control-arrow {
    right: 0;
}
.carousel .control-next.control-arrow:before {
    border-left: 8px solid #fff;
}
.carousel-root {
    outline: none;
}
.carousel {
    position: relative;
    width: 100%;
}
.carousel * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.carousel img {
    width: 100%;
    display: inline-block;
    pointer-events: none;
}
.carousel .carousel {
    position: relative;
}
.carousel .control-arrow {
    outline: 0;
    border: 0;
    background: none;
    top: 50%;
    margin-top: -13px;
    font-size: 18px;
}
.carousel .thumbs-wrapper {
    margin: 20px;
    overflow: hidden;
}
.carousel .thumbs {
    -webkit-transition: all 0.15s ease-in;
    -moz-transition: all 0.15s ease-in;
    -ms-transition: all 0.15s ease-in;
    -o-transition: all 0.15s ease-in;
    transition: all 0.15s ease-in;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    position: relative;
    list-style: none;
    white-space: nowrap;
}
.carousel .thumb {
    -webkit-transition: border 0.15s ease-in;
    -moz-transition: border 0.15s ease-in;
    -ms-transition: border 0.15s ease-in;
    -o-transition: border 0.15s ease-in;
    transition: border 0.15s ease-in;
    display: inline-block;
    margin-right: 6px;
    white-space: nowrap;
    overflow: hidden;
    border: 3px solid #fff;
    padding: 2px;
}
.carousel .thumb:focus {
    border: 3px solid #ccc;
    outline: none;
}
.carousel .thumb.selected,
.carousel .thumb:hover {
    border: 3px solid #333;
}
.carousel .thumb img {
    vertical-align: top;
}
.carousel.carousel-slider {
    position: relative;
    margin: 0;
    overflow: hidden;
    height: 330px;
    
    
    @media (min-width: ${breakpoints.desktop}) {
      height: 480px;
    }
}
.carousel.carousel-slider .control-arrow {
    top: 0;
    color: #fff;
    font-size: 26px;
    bottom: 0;
    margin: 0 0 30px 0;
    padding: 5px;
    background-color: grey;
    @media (min-width: ${breakpoints.desktop}) {
      background: transparent;
    }
}
.carousel.carousel-slider .control-arrow:hover {
    //background: rgba(0, 0, 0, 0.2);
}
.carousel .slider-wrapper {
    overflow: hidden;
    margin: auto;
    width: auto;
    -webkit-transition: height 0.15s ease-in;
    -moz-transition: height 0.15s ease-in;
    -ms-transition: height 0.15s ease-in;
    -o-transition: height 0.15s ease-in;
    transition: height 0.15s ease-in;
}
.carousel .slider-wrapper.axis-horizontal .slider {
    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
}
.carousel .slider-wrapper.axis-horizontal .slider .slide {
    flex-direction: column;
    flex-flow: column;
}
.carousel .slider-wrapper.axis-vertical {
    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
}
.carousel .slider-wrapper.axis-vertical .slider {
    -webkit-flex-direction: column;
    flex-direction: column;
}
.carousel .slider {
    margin: 0;
    padding: 0;
    position: relative;
    list-style: none;
    width: 100%;
}
.carousel .slider.animated {
    -webkit-transition: all 0.35s ease-in-out;
    -moz-transition: all 0.35s ease-in-out;
    -ms-transition: all 0.35s ease-in-out;
    -o-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
}
.carousel .slide {
    min-width: 100%;
    margin: 0;
    position: relative;
    text-align: center;
    background: #000;
}
.carousel .slide img {
    width: 100%;
    vertical-align: top;
    border: 0;
}
.carousel .slide iframe {
    display: inline-block;
    width: calc(100% - 80px);
    margin: 0 40px 40px;
    border: 0;
}
.carousel .slide .legend {
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    position: absolute;
    bottom: 40px;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    border-radius: 10px;
    background: #000;
    color: #fff;
    padding: 10px;
    font-size: 12px;
    text-align: center;
    opacity: 0.25;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;
}
.carousel .control-dots {
    position: absolute;
    margin: 0px 0;
    padding: 0;
    text-align: center;
    width: 100%;
    bottom: 0px;
}
@media (min-width: 960px) {
    .carousel .control-dots {
        bottom: 0;
    }
}
.carousel .control-dots .dot {
    -webkit-transition: opacity 0.25s ease-in;
    -moz-transition: opacity 0.25s ease-in;
    -ms-transition: opacity 0.25s ease-in;
    -o-transition: opacity 0.25s ease-in;
    transition: opacity 0.25s ease-in;
    opacity: 0.3;
    filter: alpha(opacity=30);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);
    background: #ccc;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    cursor: pointer;
    display: inline-block;
    margin: 0 8px;
    z-index: 1999;
    
    @media (min-width: ${breakpoints.desktop}) {
      width: 15px;
    height: 15px;
          }
    
}
.carousel .control-dots .dot.selected,
.carousel .control-dots .dot:hover {
    opacity: 1;
    filter: alpha(opacity=100);
}
.carousel .carousel-status {
    position: absolute;
    top: -10px;
    right: 35px;
    padding: 5px;
    font-size: 10px;
    color: #000;
    
    @media (min-width: ${breakpoints.desktop}) {
      top: 0;
      right: 0;
    }
    
}
.carousel:hover .slide .legend {
    opacity: 1;
}

.gtitle {
          font-family: arial!important;
          font-style:normal!important;
          font-size: 15px!important;
          fill: #7a7a7a!important;
          
          @media (min-width: ${breakpoints.desktop}) {
            font-size: 25px!important;
          }
      }
`;


